/* Knops tellers: rollende cijfers (zoals een kilometerteller), zacht uitlopend.
   Gebruik: KnopsCounter.prepare(el) zet de teller op 0, KnopsCounter.roll(el, getal) laat 'm naar het getal rollen.
   Zonder JS (of bij "minder beweging") blijft gewoon het getal als tekst staan. */
(function () {
  if (window.KnopsCounter) return;
  var st = document.createElement('style');
  st.textContent =
    '.kp-odo{display:inline-flex;align-items:flex-start;vertical-align:baseline;font-variant-numeric:tabular-nums}' +
    '.kp-odo__d{display:inline-block;position:relative;height:1.06em;overflow:hidden;line-height:1.06}' +
    '.kp-odo__col{display:block;will-change:transform;transform:translateY(0);transition:transform 2.1s cubic-bezier(.16,1,.3,1)}' +
    '.kp-odo__col>span{display:block;height:1.06em;line-height:1.06}' +
    '.kp-odo__s{display:inline-block;line-height:1.06}';
  document.head.appendChild(st);

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build(el, text) {
    el.textContent = '';
    el.classList.add('kp-odo');
    el.setAttribute('aria-label', text);
    var cols = [];
    String(text).split('').forEach(function (ch) {
      if (/[0-9]/.test(ch)) {
        var d = document.createElement('span'); d.className = 'kp-odo__d'; d.setAttribute('aria-hidden', 'true');
        var col = document.createElement('span'); col.className = 'kp-odo__col';
        for (var k = 0; k < 20; k++) { var n = document.createElement('span'); n.textContent = String(k % 10); col.appendChild(n); }
        d.appendChild(col); el.appendChild(d); cols.push({ col: col, digit: parseInt(ch, 10) });
      } else {
        var s = document.createElement('span'); s.className = 'kp-odo__s'; s.textContent = ch; s.setAttribute('aria-hidden', 'true'); el.appendChild(s);
      }
    });
    return cols;
  }

  /* Telefoon (feedback Erik 30-10): geen rollende cijfers maar rustig optellen, ca. 3 seconden met zachte uitloop.
     Desktop en tablet blijven de rollende cijfers houden. */
  function isPhone() { return !!(window.matchMedia && window.matchMedia('(max-width: 600px)').matches); }
  function countUp(el, to) {
    var t0 = null, dur = 3000;
    el.textContent = '0';
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(to * e));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  window.KnopsCounter = {
    prepare: function (el) {
      if (reduce || !el) return;
      if (isPhone()) { el.textContent = '0'; return; }
      var cur = build(el, '0');
      el._kpOdo = cur;
    },
    roll: function (el, value) {
      if (!el) return;
      var txt = String(Math.max(0, parseInt(value, 10) || 0));
      if (reduce) { el.textContent = txt; return; }
      if (isPhone()) { countUp(el, parseInt(txt, 10)); return; }
      var cols = build(el, txt);
      // eerst in de beginstand renderen, dan pas naar het getal laten rollen
      void el.offsetWidth;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          cols.forEach(function (c, i) {
            c.col.style.transitionDelay = (i * 110) + 'ms';
            c.col.style.transform = 'translateY(' + (-(c.digit + 10) * 5) + '%)';
          });
        });
      });
    }
  };
})();
